import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { StackProps, useTheme } from "@mui/material";

import { Stack } from "@/Components/v2/atoms/Stack";
import { Tooltip } from "@/Components/v2/atoms/ToolTip";
import { BaseTypography, Typography } from "@/Components/v2/atoms/Typography";
import { colors } from "@/Utils";

export type MetricCardProps = StackProps & {
  label: string;
  value: string;
  changeValue?: string;
  contribution?: string;
  tooltipText?: string;
};

const getChangeValue = (changeValue: string) => {
  if (changeValue.includes("-")) {
    return changeValue;
  }
  return `+${changeValue}`;
};

export const MetricCard = ({
  label,
  value,
  changeValue,
  contribution,
  tooltipText,
  ...stackProps
}: MetricCardProps) => {
  const theme = useTheme();
  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      gap={0.5}
      paddingY={3}
      paddingX={2}
      border={`1px solid ${theme.palette.section.border}`}
      borderRadius={4}
      minWidth={0}
      flex="1 1 0"
      {...stackProps}
    >
      <Stack direction="row" gap={0.5}>
        <Typography variant="body1" fontSize={14}>
          {label}
        </Typography>
        {tooltipText && (
          <Tooltip
            title={
              <Typography
                variant="body1"
                padding={1}
                fontSize={14}
                sx={{ color: theme.palette.common.white }}
              >
                {tooltipText}
              </Typography>
            }
            placement="top"
          >
            <HelpOutlineOutlinedIcon fontSize="small" />
          </Tooltip>
        )}
      </Stack>
      <Stack direction="row" alignItems="baseline" gap={1}>
        <Typography variant="h2" fontSize={24} fontWeight={600}>
          {value}
        </Typography>
        {changeValue && (
          <BaseTypography
            variant="body2"
            fontSize={18}
            fontWeight={600}
            color={changeValue.includes("-") ? colors.totalValueRed : colors.greenSuccess}
            sx={{ display: "flex", alignItems: "center", alignSelf: "center" }}
          >
            {getChangeValue(changeValue)}
          </BaseTypography>
        )}
        {contribution && (
          <Typography variant="body2" fontSize={18} fontWeight={600}>
            {contribution}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
